import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { capitalize } from 'helpers/helpers';

type Props = {
    isLoading?: boolean;
    isDisabled?: boolean;
    icon: React.ReactNode;
    onClick: () => void;
    tooltip: string;
    className?: string;
    placement?: TooltipProps['placement'];
    color?: 'default' | 'inherit' | 'primary' | 'secondary';
    iconProps?: IconButtonProps;
    'data-testid'?: string;
};
export default function TooltipIconButton({
    className = '',
    placement = 'top',
    isDisabled = false,
    isLoading = false,
    iconProps = {},
    tooltip,
    onClick,
    color = undefined,
    icon,
    'data-testid': dataTestId = undefined,
}: Props): React.ReactElement {
    return isLoading ? (
        <CircularProgress />
    ) : (
        <Tooltip title={capitalize(tooltip)} placement={placement}>
            <span data-testid={dataTestId}>
                <IconButton
                    disabled={!!isDisabled}
                    onClick={onClick}
                    className={className ? className : ''}
                    // Used for walkthrough
                    guide-value={tooltip}
                    color={color ?? 'primary'}
                    {...iconProps}
                    size="large"
                >
                    {icon}
                </IconButton>
            </span>
        </Tooltip>
    );
}
